export const axiosConfig = {
  headers: {
    "Content-Type": "application/json",
  },
};
